module.exports = __webpack_public_path__ + "./images/d0b7cb72c19c68d68a3fa5e6917d4e25.webp";